import React from 'react';
import { useAtom } from 'jotai';

import { meAtom } from '@/store/me.store';

type Props = {
  children: React.ReactElement;
  requiredRoles: string[];
};

const Authorized = ({ requiredRoles, children }: Props): React.ReactElement | null => {
  const [meUser] = useAtom(meAtom);

  const userRoles = meUser?.roles.map((role) => role.name) || [];
  const hasEveryRole = requiredRoles.every((role) => userRoles.includes(role));

  return hasEveryRole ? children : null; // eslint-disable-line unicorn/no-null
};

export default Authorized;
